const availableImages = {
    images: [
        {
            name: "nagrody"
        },
        {
            name: "nagrody1"
        },
        {
            name: "nagrody2"
        },
        {
            name: "nagrody3"
        },
        {
            name: "nagrody4"
        },
        {
            name: "nagrody5"
        }
    ]
};

export default availableImages;
